<template>
    <div>
        <h2>Additional information needed for secure login</h2>
    <div class="app-input-row"> 
    <!-- DD -->
        <div class="app-input-group" :class="{ 'app-invalid-group': !isddNumberValid }">
            <label for="ddNumberField" class="inputclass">RI DD #</label>
            <input type="text" :id="ddNumberField" :aria-describedby="`${ddNumberField}Desc`"
                    v-model="myddNum" @input="validateDdNumber" aria-required="true" @change="errorMsg=''"/>
            <p v-if="!isddNumberValid" class="app-error-message">{{ ddError }}</p>
            <p :id="`${ddNumberField}Desc`" class="sr-only">{{ getFieldDescription(`${ddNumberField}`) }}</p>
            <p :id="`${ddNumberField}Desc`" class="sr-only">Required. Up to 25 characters. Do not use comma, semicolon, less-than sign or pipe.</p>
            <p v-if="errorMsg!=''" class="error-msg">
                {{ errorMsg }}
              </p>
              <p class="sr-only" v-if="errorMsg!=''">
                {{ errorMsg }}
              </p>
        </div>

        <div >
            <div class="app-input-group">
                <img src="static/ddNumIdentification.png" alt="DD number identification. DD number is data element 5 and can be found at the bottom of your Driver license / Identification card." class="license-image">
            </div>
        </div>
    </div>

        <BaseButtonGroup>
            <button type="button" @click="handleRouting('previous')">Previous</button> 
            <CustomButton type="submit" @click="handleRouting('Next')">Next</CustomButton>
        </BaseButtonGroup>
    </div>
</template>


<script>
import BaseButtonGroup from '@/components/ui/BaseButtonGroup';
import vu from '@/utils/validationUtils';
import * as COMMONS from '../../store/_commons';
import { mapActions } from 'vuex';
import CustomButton from '../CustomButton.vue';
export default {
    name: 'UserDD',
    components: {
        BaseButtonGroup,
        CustomButton
    },
    data() {
        return {
            ddNumberField: 'ddNumber',
            myddNum: '',
            isddNumberValid: true,
            numericPattern: /^[0-9]+$/,
            namePattern: /^[a-zA-Z0-9!@#$%^&*()_+=[\]{}\u2018\u2019':"\\.>/?`~ ]*$/,
            inputPattern: /^[a-zA-Z0-9]*$/,
            errorMsg: '',
            count: 0,
        }
    },
    computed: {
        ddError() {
        const isddNumberValid = (this.myddNum.length > 0) && this.numericPattern.test(this.myddNum) && this.myddNum.length <= 10 && this.myddNum !=='1';

        if (!isddNumberValid) {
            const val = this.myddNum;
            let errorCode;
            if (val.length <= 0) {
                errorCode = '08';      
            }
            // override empty field error message
            if (!this.numericPattern.test(val) ||  this.myddNum !=='1') {
                errorCode = '08';       // no special chars
            }
            if (this.myddNum.length > 10) {
                errorCode = '09';
            }
            return this.getFieldErrorMessage(this.ddNumberField, errorCode);
            }
            return '';
        },

        validationMessages() {
            return [
                { ref: this.ddNumberField, code: '08', message: 'A valid DD # is required. Please refer to the image for help on where to locate the DD # on your License / ID card.' },
                { ref: this.ddNumberField, code: '09', message: 'DD # is limited to 10 characters. Please refer to the image for help on where to locate the DD # on your License / ID card.' },  
            ];
        },
    },
    created() {

    },
    mounted() {
        window.scroll(0,0);
        document.body.setAttribute("tabindex", "1");
        document.body.focus();

        document.body.removeAttribute("tabindex");
        document.getElementById("app").scrollTop = 0;
    },
    methods: {
        ...mapActions({
            getGuestLogin : COMMONS.GUEST_LOGIN_GET_LOGIN,
        }),

        getFieldErrorMessage(ref, code=undefined) {
            return vu.getFieldValidationMessage(this.validationMessages, ref, code);
        },
        getFieldDescription(ref) {
            return vu.getFieldAccessibleDescription(this.validationMessages, ref);
        },
        validateDdNumber() {
            const val = this.myddNum;
            this.isddNumberValid = (val.length > 0) && this.numericPattern.test(val) && val.length <= 10 && val !=='1';
        },
        async handleRouting(info) {
            if(info=='previous') {
                this.$store.state.guestLogin.mfaStep = 3;
                if(this.count >= 3) {
                    this.$router.push({name: 'GuestSignin'});
                }
            }
            else {
                if(this.myddNum !='' && this.myddNum != null) {
                    this.count = this.count+1;
                    let payloadData = {
                    verificationCode: this.myddNum,
                    attemptValue: this.count
                }
                await this.getGuestLogin(payloadData);
                } 
                else {
                    this.errorMsg = 'RI DD# is required'
                }
            }
        }
    },
    beforeDestroy() {
        this.$store.state.networkResponse = null;
    }
}
</script>


<style lang="scss" scoped>

h2 {
    margin-top: 2rem;
}
.app-input-row {
    margin-top: 1.5rem;
}
.error-msg{
    color: var(--ri-red);
}

</style>